<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <rect x="0.5" y="1" width="17" height="5" rx="2.5" stroke="white" />
  <path d="M0.900391 10.5H17.1004" stroke="white" />
  <path d="M0.900391 15.5H17.1004" stroke="white" />
</svg>
